import { useState } from "react";
import { IoClose } from "react-icons/io5";
import "./AddTask.css";
const AddTask = ({ onClose, handleTasksSubmit }) => {
    const date = new Date();
    const day = date.getDate();
    const currentMonth = date.getMonth();
    const currentYear = date.getFullYear();
    const currentDay = date.getDay();
    const currentDate = date.getDate();
    const [task, setTask] = useState([]);
    const [addedTask, setAddedTask] = useState(1);
    const [selectedMonth, setSelectedMonth] = useState(currentMonth);
    const [selectedWeek, setSelectedWeek] = useState(1);
    const [selectedDay, setSelectedDay] = useState(currentDay);
    const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const handleTaskInput = (e, index) => {
        const temp = task.map((task) => task);
        temp[index] = e.target.value;
        setTask(temp);
    }
    const handleAddMore = () => {
        setAddedTask(addedTask + 1);
    }
    const handleSubmit = () => {
        const firstDayOfMonth = new Date(currentYear, selectedMonth - 1, 1);
        const firstDayOfMonthIndex = firstDayOfMonth.getDay();
        const firstDayOfSelectedWeek = new Date(currentYear, selectedMonth - 1, selectedDay - firstDayOfMonthIndex + (selectedWeek - 1) * 7);

        const day = firstDayOfSelectedWeek.getDate();
        const month = monthNames[selectedMonth];
        const year = firstDayOfSelectedWeek.getFullYear();
        handleTasksSubmit({ tasks: task, day, month, year });
    };
    const getRemainingWeeks = (month, year) => {
        var firstOfMonth = new Date(year, month, 1);
        var day = firstOfMonth.getDay() || 6;
        day = day === 1 ? 0 : day;
        if (day) { day-- }
        var diff = 7 - day;
        var lastOfMonth = new Date(year, month, 0);
        var lastDate = lastOfMonth.getDate();
        if (lastOfMonth.getDay() === 1) {
            diff--;
        }
        var result = Math.ceil((lastDate - diff) / 7);
        return result;
    };

    const getRemainingDaysInWeek = () => {
        const today = new Date();
        const currentDay = today.getDay();
        const remainingDays = [];
        for (let i = currentDay; i < 6; i++) {
            remainingDays.push((i + 1) % 7 || 7);
        }
        return remainingDays;
    };
    const remainingMonths = Array.from({ length: 12 - currentMonth }).map((_, monthIndex) => {
        const nextMonthIndex = currentMonth + monthIndex;
        return {
            value: nextMonthIndex,
            label: new Date(currentYear, nextMonthIndex).toLocaleString("default", { month: "long" })
        };
    });
    const remainingWeeks = getRemainingWeeks(selectedMonth, currentYear);
    const remainingDaysInWeek = getRemainingDaysInWeek();
    return (
        <div className="modal-container">
            <div className="task-modal">
                <div className="taskclose-icon" onClick={onClose}>
                    <IoClose size={18} />
                </div>
                <div>
                    <div className="addtask-date">
                        <select
                            value={selectedMonth}
                            onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
                        >
                            {remainingMonths.map((month) => (
                                <option key={month.value} value={month.value}>
                                    {month.label}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="addtask-divs">
                        {
                            [...Array(addedTask)].map((_, index) => (
                                <div className="addtask-div">
                                    <div className="addtask-head">
                                        <p>Task {index + 1}</p>
                                        <div className="addtask-date second">
                                            <select
                                                value={selectedDay}
                                                onChange={(e) => setSelectedDay(parseInt(e.target.value))}
                                            >
                                                {remainingDaysInWeek.map((day, index) => (
                                                    <option key={index} value={day}>
                                                        {day}
                                                    </option>
                                                ))}
                                            </select>
                                            <div className="filter-divide" />
                                            <select
                                                value={selectedWeek}
                                                onChange={(e) => setSelectedWeek(parseInt(e.target.value))}
                                            >
                                                {[...Array(remainingWeeks)].map((_, index) => (
                                                    <option key={index} value={index + 1}>
                                                        Week {index + 1}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="task-input">
                                        <textarea onChange={(e) => handleTaskInput(e, index)} />
                                    </div>
                                </div>
                            ))
                        }
                    </div>

                </div>
                <div>
                    {
                        addedTask < 5 && <div className="addtask-btn" onClick={handleAddMore}>
                            <p>Add more tasks</p>
                        </div>
                    }
                    <button type="submit" className="save-task" onClick={handleSubmit}>
                        Save
                    </button>
                </div>
            </div>
        </div>
    )
}

export default AddTask;